import React from "react";
import "./CSS/Categories.css";
import { useNavigate } from "react-router-dom";
import crdbg from "./IMAGES/030baf24263fe4ae6abe7c3522b06880211742a7.png";

import saree from "./IMAGES/Weaving_Work_Rani_Color_Paithani_Silk_Fabric_Splendid_Saree_-_Pink___Art_Silk___Weaving_Work-removebg-preview 1.png";
import kurti from "./IMAGES/download__1_-removebg-preview 1.png";
import dresses from "./IMAGES/Kashmiri-removebg-preview 1.png";
import blouse from "./IMAGES/Maliha_-_Rosepink_Saree_Set_-_Rose_Pink___5XL___Open-removebg-preview 1.png";
import tops from "./IMAGES/download__6_-removebg-preview 1.png";

const Categories = () => {
   const navigate = useNavigate();
 const data = [
  { title: "Saree", img: saree, bg: crdbg },
  { title: "Kurti Sets", img: kurti, bg: crdbg },
  { title: "Dresses", img: dresses, bg: crdbg },
  { title: "Blouse", img: blouse, bg: crdbg },
  { title: "Tops", img: tops, bg: crdbg },
];

  return (
    <div className="categories-container">
      <div className="categories-header">
        <div>
          <h1>Exclusive Categories</h1>
          <p>
            Explore our handcrafted collections, tailored for every generation.
          </p>
        </div>
 <span 
      className="see-all"
      onClick={() => navigate("/shop")}
      style={{ cursor: "pointer" }}
    >
      See all
    </span>      </div>

      <div className="categories-card-wrapper">
        {data.map((item, index) => (
    <div className="categories-card" key={index}   onClick={() => navigate("/shop")}
      style={{ cursor: "pointer" }}>
  <div
    className="arch"
    style={{
      background: `url(${item.bg}) center / cover no-repeat`,
    }}
  >
<h3>
  {item.title}
  
</h3>
    <img src={item.img} alt={item.title} />
  </div>
</div>
        ))}
      </div>
    </div>
  );
};

export default Categories;